export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8564.cc0ad718.jpg";